import React from "react";
import { Box, Typography, IconButton, Tooltip, Chip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faCubes,
  faBox,
  faLock,
} from "@fortawesome/free-solid-svg-icons";

export const VolumeItem = React.memo(
  ({ item, onRemove, locked = false, shipmentId = null }) => {
    if (!item) return null;

    const isEquipment = item.type === "equipment";

    const handleRemove = () => {
      if (locked) return;
      onRemove();
    };

    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          px: 1.5,
          py: 0.75,
          backgroundColor: isEquipment ? "#f5f5f5" : "#fafafa",
          borderRadius: "4px",
          borderLeft: `3px solid ${isEquipment ? "#9c27b0" : "#1976d2"}`,
          opacity: locked ? 0.7 : 1,
          "&:hover": {
            backgroundColor: isEquipment ? "#eeeeee" : "#f0f0f0",
          },
        }}>
        <FontAwesomeIcon
          icon={isEquipment ? faCubes : faBox}
          style={{
            color: isEquipment ? "#9c27b0" : "#1976d2",
            fontSize: "14px",
            width: "16px",
          }}
        />

        <Box sx={{ flex: 1, minWidth: 0 }}>
          {isEquipment ? (
            <>
              <Typography
                variant="body2"
                fontWeight="bold"
                noWrap
                sx={{ textTransform: "uppercase" }}>
                {item.equipment_number} - {item.equipment_name}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Equipamento • 1 unidade
              </Typography>
            </>
          ) : (
            <>
              <Typography
                variant="body2"
                fontWeight="bold"
                noWrap
                sx={{ textTransform: "uppercase" }}>
                {item.product_code} - {item.product_name}
              </Typography>
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="caption" color="text.secondary">
                  {item.product_category} | {item.product_condition}
                </Typography>
                <Chip
                  label={`${item.quantity} un`}
                  size="small"
                  color="primary"
                  sx={{
                    height: 18,
                    fontSize: "0.7rem",
                    "& .MuiChip-label": { px: 1 },
                  }}
                />
              </Box>
            </>
          )}
        </Box>

        {/* Botão de remover - DESABILITADO se locked */}
        {locked ? (
          <Tooltip
            title={`Item bloqueado: volume vinculado ao carregamento #${shipmentId}`}
            placement="top">
            <span>
              <IconButton size="small" disabled sx={{ ml: 1 }}>
                <FontAwesomeIcon
                  icon={faLock}
                  fontSize="small"
                  style={{ color: "#ff9800" }}
                />
              </IconButton>
            </span>
          </Tooltip>
        ) : (
          <Tooltip title="Remover do Volume">
            <IconButton
              size="small"
              color="error"
              onClick={handleRemove}
              sx={{ ml: 1 }}>
              <FontAwesomeIcon icon={faTrash} fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.item?.id === nextProps.item?.id &&
      prevProps.item?.identify === nextProps.item?.identify &&
      prevProps.item?.quantity === nextProps.item?.quantity &&
      prevProps.onRemove === nextProps.onRemove &&
      prevProps.locked === nextProps.locked &&
      prevProps.shipmentId === nextProps.shipmentId
    );
  },
);
